import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { OrdersListDto } from '../../dto/orders-list.dto';
import { HeaderDto } from '../../dto/header.dto';
import { Status } from '../../dto/status.enum';
import { SearchItem } from '../../dto/search-item.dto';

@Component({
  selector: 'app-orders-page',
  templateUrl: './orders-page.component.html',
  styleUrls: ['./orders-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrdersPageComponent implements OnInit {
  @Input() headerData: HeaderDto = {
    statuses: [],
    totalCount: 0,
    title: '',
    tabRoute: ''
  };

  @Input() ordersListData: OrdersListDto = { statuses: [], searchTerms: [] };
  @Input() tabName: string = '';

  showSearch: boolean = false; // Показывать поиск только для 'requests'
  showFilter: boolean = false; // Показывать фильтр только для 'archived-requests'

  constructor(
    private route: ActivatedRoute,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // Определяем, показывать ли поиск или фильтр в зависимости от tabName

    // Подписка на queryParams только для архива
    if (this.tabName === 'archived-requests') {
      this.route.queryParams.subscribe(params => {
        const { status } = params;
        if (status === 'COMPLETED') {
          this.switchArchiveTab(status);
        }
      });
    }

    // Инициализация через данные маршрута, если они есть
    this.route.data.subscribe(data => {
      this.headerData = data['headerData'] || this.headerData;
      this.ordersListData = data['ordersListData'] || this.ordersListData;
      this.tabName = data['tabName'] || this.tabName;
      this.showSearch = this.tabName === 'requests';
      this.showFilter = this.tabName === 'archived-requests';
      this.cd.markForCheck();
    });
  }

  getSearchTerms(searchTerms: SearchItem[]) {
    if (!this.showSearch) return; // Только для 'requests'
    this.ordersListData = {
      ...this.ordersListData,
      searchTerms: [...searchTerms]
    };
    this.cd.markForCheck();
  }

  getTotalCount(totalCount: number) {
    this.headerData = {
      ...this.headerData,
      totalCount
    };
    this.cd.markForCheck();
  }

  switchArchiveTab(status: Status) {
    if (!this.showFilter) return; // Только для 'archived-requests'
    const newListDataValues = _.cloneDeep(this.ordersListData);
    newListDataValues.statuses = [status];
    this.ordersListData = newListDataValues;
    this.cd.markForCheck();
  }
}
